import Vue from "vue";
import VueRouter from "vue-router";
// import store from "../store/index";

import { CL } from "../Tools/loading"; // 开启/关闭加载图
import { isCK } from "../Tools/storage"; // 本地储存LS与服务器储存SS
import { wMsg } from "../Tools/msg"; // 警告信息 s成功 w警告 e错误 (msgtext)
import login from "../components/view/login.vue"; //登录视图
// import home from "../components/view/home.vue"; // 主页视图

Vue.use(VueRouter);

let routes = [
  {
    path: "/",
    name: "login",
    component: login,
    meta: {
      isShow: false
    }
  },
  {
    name: "home",
    path: "/home",
    meta: {
      title: "首页",
      isShow: false,
      data: [
        {
          to: "/home",
          text: "首页",
        }
      ],
    },
    component: () => import("../components/view/home.vue"),
  },
  // 公告管理
  {
    name: "publicManagement",
    path: "/publicManagement",
    meta: {
      title: "公告管理",
      isShow: true,
      data: [
        {
          to: "/home",
          text: "首页",
        }, {
          to: "/publicManagement",
          text: "公告管理",
        }
      ],
    },

    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/announce",
        name: "announce",
        component: () => import("../components/view/publicManagement/announce.vue"),
        meta: {
          isShow: true,
          title: "发布公告",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/announce",
              text: "发布公告",
            }
          ],
        },

      },
    ],
  },
  // 运营收入管理
  {
    name: "operationsManagement",
    path: "/operationsManagement",
    meta: {
      title: "运营收入管理",
      isShow: true,
      data: [
        {
          to: "/home",
          text: "首页",
        }, {
          to: "/operationsManagement",
          text: "运营收入管理",
        }
      ],
    },
    component: () => import("../components/view/home.vue"),
    children: [
      // {
      //   path: "/incomeStatistics",
      //   name: "incomeStatistics",
      //   component: () => import("../components/view/operationsManagement/incomeStatistics.vue"),
      //   meta: {
      //     isShow: true,
      //     title: "运营收入统计",
      //     data: [
      //       {
      //         to: "/home",
      //         text: "首页",
      //       }, {
      //         to: "/incomeStatistics",
      //         text: "运营收入统计",
      //       }
      //     ],
      //   },
      // },
      {
        path: "/incomeDetail",
        name: "incomeDetail",
        component: () => import("../components/view/operationsManagement/incomeDetail.vue"),
        meta: {
          isShow: true,
          title: "运营收入明细",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/incomeDetail",
              text: "运营收入明细",
            }
          ],
        },
      },
      // {
      //   path: "/servicProvider",
      //   name: "servicProvider",
      //   component: () => import("../components/view/operationsManagement/servicProvider.vue"),
      //   meta: {
      //     isShow: true,
      //     title: "服务商收益统计",
      //     data: [
      //       {
      //         to: "/home",
      //         text: "首页",
      //       }, {
      //         to: "/servicProvider",
      //         text: "服务商收益统计",
      //       }
      //     ],
      //   },
      // },
    ],
  },
  // 门户运营管理
  {
    name: "portalManagement",
    path: "/portalManagement",
    meta: {
      title: "门户运营管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/consult",
        name: "consult",
        component: () => import("../components/view/portalManagement/consult.vue"),
        meta: {
          isShow: true,
          title: "咨询管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/consult",
              text: "咨询管理",
            }
          ],
        },
      },
      // {
      //   path: "/news",
      //   name: "news",
      //   component: () => import("../components/view/portalManagement/news.vue"),
      //   meta: {
      //     isShow: true,
      //     title: "新闻管理",
      //     data: [
      //       {
      //         to: "/home",
      //         text: "首页",
      //       }, {
      //         to: "/news",
      //         text: "新闻管理",
      //       }
      //     ],
      //   },
      // },
    ],
  },
  // 超市运营管理
  {
    name: "SupermarketOperation",
    path: "/SupermarketOperation",
    meta: {
      title: "超市运营管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/application",
        name: "application",
        component: () => import("../components/view/SupermarketOperation/application.vue"),
        meta: {
          isShow: true,
          title: "应用上架审核",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/application",
              text: "应用上架审核",
            }
          ],
        },
      },
        {
        path: "/applicationUpload",
        name: "applicationUpload",
        component: () => import("../components/view/SupermarketOperation/applicationUpload.vue"),
        meta: {
          isShow: true,
          title: "应用上传审核",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/applicationUpload",
              text: "应用上架审核",
            }
          ],
        },
      },
      {
        path: "/lowcode",
        name: "lowcode",
        component: () => import("../components/view/SupermarketOperation/lowcode.vue"),
        meta: {
          isShow: true,
          title: "构建应用审核",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/lowcode",
              text: "构建应用审核",
            }
          ],
        },
      },
      {
        path: "/applicationMessage",
        name: "applicationMessage",
        component: () => import("../components/view/SupermarketOperation/applicationMessage.vue"),
        meta: {
          isShow: true,
          title: "应用信息管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/applicationMessage",
              text: "应用信息管理",
            }
          ],
        },
      },
      {
        path: "/applicationConsult",
        name: "applicationConsult",
        component: () => import("../components/view/SupermarketOperation/applicationConsult.vue"),
        meta: {
          isShow: true,
          title: "应用咨询管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/applicationConsult",
              text: "应用咨询管理",
            }
          ],
        },
      },
      {
        path: "/customization",
        name: "customization",
        component: () => import("../components/view/SupermarketOperation/customization.vue"),
        meta: {
          isShow: true,
          title: "定制咨询管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/customization",
              text: "定制咨询管理",
            }
          ],
        },
      },
      {
        path: "/userEvaluation",
        name: "userEvaluation",
        component: () => import("../components/view/SupermarketOperation/userEvaluation.vue"),
        meta: {
          isShow: true,
          title: "用户评价管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/userEvaluation",
              text: "用户评价管理",
            }
          ],
        },
      },
      {
        path: "/UserApplication",
        name: "UserApplication",
        component: () => import("../components/view/SupermarketOperation/UserApplication.vue"),
        meta: {
          isShow: true,
          title: "用户应用管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/UserApplication",
              text: "用户应用管理",
            }
          ],
        },
      },
      {
        path: "/servicManagement",
        name: "servicManagement",
        component: () => import("../components/view/SupermarketOperation/servicManagement.vue"),
        meta: {
          isShow: true,
          title: "服务商管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/servicManagement",
              text: "服务商管理",
            }
          ],
        },
      },
    ],
  },
  // 社区运营管理
  {
    name: "community",
    path: "/community",
    meta: {
      title: "社区运营管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/postManagement",
        name: "postManagement",
        component: () => import("../components/view/community/postManagement.vue"),
        meta: {
          isShow: true,
          title: "帖子列表",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/postManagement",
              text: "帖子列表",
            }
          ],
        },
      },
      {
        path: "/postAudit",
        name: "postAudit",
        component: () => import("../components/view/community/postAudit.vue"),
        meta: {
          isShow: true,
          title: "举报审核",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/postAudit",
              text: "举报审核",
            }
          ],
        },
      },
      {
        path: "/postRecord",
        name: "postRecord",
        component: () => import("../components/view/community/postRecord.vue"),
        meta: {
          isShow: true,
          title: "举报审核记录",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/postRecord",
              text: "举报审核记录",
            }
          ],
        },
      },
      // {
      //   path: "/disabledPost",
      //   name: "disabledPost",
      //   component: () => import("../components/view/community/disabledPost.vue"),
      //   meta: {
      //     isShow: true,
      //     title: "禁言管理",
      //     data: [
      //       {
      //         to: "/home",
      //         text: "首页",
      //       }, {
      //         to: "/disabledPost",
      //         text: "禁言管理",
      //       }
      //     ],
      //   },
      // },
    ],
  },
  // 认证审核管理
  {
    name: "certificationAudit",
    path: "/certificationAudit",
    meta: {
      title: "认证审核管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/developer",
        name: "developer",
        component: () => import("../components/view/certificationAudit/developer.vue"),
        meta: {
          isShow: true,
          title: "开发者认证管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/developer",
              text: "开发者认证管理",
            }
          ],
        },
      },
      {
        path: "/enterprise",
        name: "enterprise",
        component: () => import("../components/view/certificationAudit/enterprise.vue"),
        meta: {
          isShow: true,
          title: "企业认证管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/enterprise",
              text: "企业认证管理",
            }
          ],
        },
      },
      {
        path: "/servicAudit",
        name: "servicAudit",
        component: () => import("../components/view/certificationAudit/servicAudit.vue"),
        meta: {
          isShow: true,
          title: "服务商认证管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/servicAudit",
              text: "服务商认证管理",
            }
          ],
        },
      },
    ],
  },
  // 资源审核管理
  {
    name: "resourcesManagement",
    path: "/resourcesManagement",
    meta: {
      title: "资源审核管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/resourceApplication",
        name: "resourceApplication",
        component: () => import("../components/view/resourcesManagement/resourceApplication.vue"),
        meta: {
          isShow: true,
          title: "应用服务管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/resourceApplication",
              text: "应用服务管理",
            }
          ],
        },
      },
      {
        path: "/examplesApplication",
        name: "examplesApplication",
        component: () => import("../components/view/resourcesManagement/examplesApplication.vue"),
        meta: {
          isShow: true,
          title: "实例资源管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/examplesApplication",
              text: "实例资源管理",
            }
          ],
        },
      },
      {
        path: "/msqManagement",
        name: "msqManagement",
        component: () => import("../components/view/resourcesManagement/msqManagement.vue"),
        meta: {
          isShow: true,
          title: "数据库接入管理",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/msqManagement",
              text: "数据库接入管理",
            }
          ],
        },
      },
    ],
  },
  // 日志管理
  {
    name: "logsManagement",
    path: "/logsManagement",
    meta: {
      title: "日志管理",
      isShow: true,
      data: [
        {
          to: "/home",
          text: "首页",
        }, {
          to: "/logsManagement",
          text: "日志管理",
        }
      ],
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/logs",
        name: "logs",
        component: () => import("../components/view/logsManagement/logs.vue"),
        meta: {
          isShow: true,
          title: "日志记录",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/logs",
              text: "日志记录",
            }
          ],
        },
      },
    ],
  },
  // 用户管理
  {
    name: "user",
    path: "/user",
    meta: {
      title: "用户管理",
      isShow: true
    },
    component: () => import("../components/view/home.vue"),
    children: [
      {
        path: "/userListByRole",
        name: "userListByRole",
        component: () => import("../components/view/user/userListByRole.vue"),
        meta: {
          isShow: true,
          title: "用户列表",
          data: [
            {
              to: "/home",
              text: "首页",
            }, {
              to: "/userListByRole",
              text: "用户列表",
            }
          ],
        },
      },
    ],
  },
];
const router = new VueRouter({
  mode: 'history',
  routes,
});
// 注册全局导航守卫
router.beforeEach((to, from, next) => {
  let isLogin = isCK('token') // 假设用户没有登录
  next()
  if (!isLogin && to.path != '/') {
    wMsg('请先登录')
    next({ path: '/' })
  }
})
router.afterEach((to, from) => {
  CL();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
